
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
form{
  display:flex;
  flex-direction:column;
}

.js-webform-checkboxes,
.js-webform-radios{
  display:flex;
  flex-direction:column;
  row-gap:1rem;
  padding:1rem 0;
}

.js-form-type-checkbox,
.js-form-type-radio{
  display:flex;
  align-items:center;
  column-gap:1rem;
}

input[type='checkbox'],
input[type='radio']{
  color:var(--gray-600);
  height:18px;
  width:18px;
  appearance:none;
  -webkit-appearance:none;
  position:relative;
  border:3px solid #fff;
  box-shadow:0 0 0 1px var(--gray-600);
  cursor:pointer;
  aspect-ratio:1 / 1;
}

input[type='checkbox']:checked, input[type='radio']:checked{
    background:var(--brand-primary-2);
  }

input[type='checkbox']:checked + label, input[type='radio']:checked + label{
      font-weight:var(--fw-black);
    }

input[type='checkbox']:disabled, input[type='radio']:disabled{
    box-shadow:0 0 0 1px var(--gray-400);
    pointer-events:none;
    cursor:none;
  }

input[type='checkbox']:disabled:checked, input[type='radio']:disabled:checked{
      background:var(--gray-400);
    }

input[type='checkbox']:disabled + label, input[type='radio']:disabled + label{
      color:var(--gray-400);
    }

input[type='checkbox']:focus:before, input[type='radio']:focus:before{
      content:'';
      position:absolute;
      width:calc(100% + 12px);
      height:calc(100% + 12px);
      top:-6px;
      left:-6px;
      border:1px solid var(--brand-primary-1);
    }

input[type='checkbox'] + label, input[type='radio'] + label{
    color:var(--gray-800);
    font-family:var(--ff-dmsans);
    font-weight:var(--fw-normal);
    font-size:var(--fs-sm);
  }

input[type='radio']{
  border-radius:50%;
}

input[type='radio']:focus:before{
      border-radius:50%;
    }

textarea,
input[type='text'],
input[type='password'],
input[type='email'],
input[type='number'],
input[type='url'],
input[type='tel']{
  border:solid 1px var(--gray-400);
  resize:none !important;
  padding:0.5rem !important;
}

textarea:focus, input[type='text']:focus, input[type='password']:focus, input[type='email']:focus, input[type='number']:focus, input[type='url']:focus, input[type='tel']:focus{
    outline:1px solid var(--brand-primary-2);
    border:solid 1px var(--brand-primary-2);
  }

textarea:disabled, input[type='text']:disabled, input[type='password']:disabled, input[type='email']:disabled, input[type='number']:disabled, input[type='url']:disabled, input[type='tel']:disabled{
    cursor:none;
    pointer-events:none;
    background-color:var(--gray-200);
    border:solid 1px var(--gray-600);
  }

textarea::placeholder, input[type='text']::placeholder, input[type='password']::placeholder, input[type='email']::placeholder, input[type='number']::placeholder, input[type='url']::placeholder, input[type='tel']::placeholder{
    color:var(--gray-400);
    font-family:var(--ff-dmsans);
  }

input[type='text'],
input[type='password']{
  height:50px;
}

.js-form-type-email,
.js-form-type-number,
.js-form-type-url,
.js-form-type-tel,
.js-form-type-textfield,
.js-form-type-password,
.js-form-type-textarea,
.js-form-type-select{
  display:flex;
  flex-direction:column;
}

.form-select{
  border:none;
  height:50px;
  width:100%;
  top:0;
  border:solid 1px var(--gray-400);
  font-family:var(--ff-dmsans);
  font-weight:var(--fw-normal);
  font-size:var(--fs-base);
  background-color:var(--brand-neutral-white);
  padding:0px 3rem 0 1rem;
  -webkit-appearance:none;
          appearance:none;
  background-image:url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' fill='%231C4BB8' viewBox='0 0 24 16'%3E%3Cpath d='M23.552 3.7 12.064 15.187l-3.699-3.7L19.854 0z'/%3E%3Cpath d='m4.254.02 11.489 11.488-3.7 3.7L.556 3.717 4.255.02Z'/%3E%3C/svg%3E");
  background-size:20px;
  background-repeat:no-repeat;
  background-position-y:center;
  background-position-x:calc(100% - 20px);
}

.js-form-item label{
    color:var(--gray-800);
    font-family:var(--ff-dmsans);
    font-weight:var(--fw-normal);
    font-size:var(--fs-sm);
  }

.description{
  display:none;
}

textarea:required:invalid,
input:required:invalid{
  position:relative;
  border:var(--status-error) solid 2px;
  background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='19' height='19' viewBox='0 0 19 19' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.53625 0C4.34515 0 0.136719 4.10417 0.136719 9.16667C0.136719 14.2292 4.34515 18.3333 9.53625 18.3333C14.7274 18.3333 18.9358 14.2292 18.9358 9.16667C18.9358 4.10417 14.7274 0 9.53625 0ZM10.3908 5C10.3908 4.77899 10.3007 4.56702 10.1405 4.41074C9.98023 4.25446 9.76288 4.16667 9.53625 4.16667C9.30963 4.16667 9.09228 4.25446 8.93203 4.41074C8.77178 4.56702 8.68175 4.77899 8.68175 5V10C8.68175 10.221 8.77178 10.433 8.93203 10.5893C9.09228 10.7455 9.30963 10.8333 9.53625 10.8333C9.76288 10.8333 9.98023 10.7455 10.1405 10.5893C10.3007 10.433 10.3908 10.221 10.3908 10V5ZM10.3908 12.9167C10.3908 12.6957 10.3007 12.4837 10.1405 12.3274C9.98023 12.1711 9.76288 12.0833 9.53625 12.0833C9.30963 12.0833 9.09228 12.1711 8.93203 12.3274C8.77178 12.4837 8.68175 12.6957 8.68175 12.9167V13.3333C8.68175 13.5543 8.77178 13.7663 8.93203 13.9226C9.09228 14.0789 9.30963 14.1667 9.53625 14.1667C9.76288 14.1667 9.98023 14.0789 10.1405 13.9226C10.3007 13.7663 10.3908 13.5543 10.3908 13.3333V12.9167Z' fill='%23991300'/%3E%3C/svg%3E");
  background-repeat:no-repeat;
}

textarea:required:invalid:after, input:required:invalid:after{
    position:absolute !important;
    overflow:hidden;
    clip:rect(1px, 1px, 1px, 1px);
    width:1px;
    height:1px;
    word-wrap:normal;
    content:'This field is required';
  }

textarea:required:invalid:focus, input:required:invalid:focus{
    outline:2px solid var(--brand-primary-2);
  }

input:required:invalid{
  background-position-x:calc(100% - 8px);
  background-position-y:50%;
}

textarea:required:invalid{
  background-position-x:calc(100% - 8px);
  background-position-y:calc(0% + 8px);
}
`;